import {
  DataType as CapabilityDataType,
  Operation as CapabilityOperation,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/capability.pb';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore } from '@frontend/scope';
import { useLocalStorage } from '@frontend/web-storage';
import { useGetSchedulerV3FeatureFlagDetails } from './use-get-scheduler-v3-feature-flag-details';

const LOCALSTORAGE_KEY = 'weave.operatory-v3-ff-override';

export const useCheckV3OperatorySupport = () => {
  const { selectedGroupId } = useAppScopeStore();
  const { isScheduleV3FlagEnabled, isLoading: isLoadingSchedulerV3Flag } = useGetSchedulerV3FeatureFlagDetails();

  const [isOperatoryV3FFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  // Capability check
  const { hasIntegrationCapability: hasListOperatoryCapability, isLoading: isLoadingCreateAppointmentCapability } =
    SchedulerV3.Helpers.useCheckIntegrationCapability(
      { type: CapabilityDataType.OPERATORY, operation: CapabilityOperation.LIST },
      selectedGroupId
    );

  // Integration check
  const { isIntegratedOffice, isLoading: isLoadingIntegrations } = DataSourcesQueries.useGetAccessibleIntegrations();

  const isLoading = isLoadingCreateAppointmentCapability || isLoadingIntegrations || isLoadingSchedulerV3Flag;
  const isV3OperatorySupported =
    (!isLoading && isScheduleV3FlagEnabled && isIntegratedOffice && hasListOperatoryCapability) ||
    !!isOperatoryV3FFOverride;

  return {
    isV3OperatorySupported,
    isLoading,
  };
};
